const isValidEmail = (email) => {
    const emailPattern = /^([a-z0-9._%-]+@[a-z.-]+\.[a-z]{2,})$/;
    const domainPattern = /@sciative\.com$|@sciative\.in$/;

    return emailPattern.test(email) && domainPattern.test(email);
}


export default isValidEmail;